var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
const SvgGroup1239 = _ref => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 50 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.1.895H11.453C5.128.895 0 5.563 0 11.322v24.26c0 5.76 5.128 10.428 11.453 10.428H38.1c6.325 0 11.453-4.669 11.453-10.427V11.322C49.553 5.563 44.425.895 38.1.895Z",
    fill: "#EB0027"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.461 16.862c2.809 0 5.086-2.073 5.086-4.63 0-2.558-2.277-4.631-5.086-4.631s-5.086 2.073-5.086 4.63c0 2.558 2.277 4.63 5.086 4.63ZM36.117 12.688c.281-1.083-.456-2.168-1.645-2.424-1.19-.255-2.382.415-2.662 1.498-.281 1.083.456 2.168 1.645 2.424 1.19.256 2.382-.415 2.662-1.498ZM27.519 39.3c2.505 0 4.535-4.168 4.535-9.31s-2.03-9.31-4.535-9.31c-2.505 0-4.535 4.168-4.535 9.31s2.03 9.31 4.535 9.31Z",
    fill: "#3B3735"
  })));
};
export { SvgGroup1239 as ReactComponent };
export default __webpack_public_path__ + "10dbb82ce65d0822e4e1ccdf4f03e067.svg";